import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import { RouterModule, Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { environment } from "../../environments/environment";
import { emaUtils } from "../EmaSystemsComponentsV1_0_0/ema-utils/documents-utils";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationEmailAndMessageService } from "../services/notification-email-and-message.service";
import { EmployeesService } from "../services/employees.service";
import { CompanyService } from "../services/company.service";
import { companySecModel } from "../model/companySecModel";
import { error } from "console";
import { BucketService } from "../EmaSystemsComponentsV1_0_0/bucket/bucket";
// "./login-v10.component.css",
//"./login-v10.component.scss",
@Component({
  selector: "app-login-v10",
  templateUrl: "./login-v10.component-v1-0-0.html",
  styleUrls: [
    "./login-v10.component-v1-0-0.scss",
    "./customers-slides.scss",
    "./login-v10.component.css",
    "./../component/ema-styles-v1/ema-forms-v1.scss",
    "./../component/ema-styles-v1/ema-modal.scss",
  ],
  providers: [
    AuthService,
    emaUtils,
    CompanyService,
    EmployeesService,
    NotificationEmailAndMessageService,
  ],
})
export class LoginV10Component implements OnInit {
  company_img = null;
  //"https://aionsystems.s3.us-west-2.amazonaws.com/mantix/E5zTrxmXEAEfsOb.jpg";
  msg = "";
  staticAlertClosedLogin = true;
  alertLogin: IAlert;
  development_indicator: String;
  hidden_denvironment_text: boolean;
  @ViewChild("changePasswordModal", { static: true })
  change_password_modal: ElementRef;
  version_str: string = environment.version_app;
  constructor(
    private tools: emaUtils,
    private authService: AuthService,
    private routes: Router,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private employee_service: EmployeesService,
    private company_service: CompanyService,
    private notificationService: NotificationEmailAndMessageService,
    private bucketService: BucketService
  ) {
    ////console.log("Ambiente:", environment.ambiente);

    if (!environment.production) {
      this.development_indicator = environment.descrpcion_ambiente;
      this.hidden_denvironment_text = false;
    } else {
      this.development_indicator = "";
      this.hidden_denvironment_text = false;
    }
    this.alertLogin = {
      id: 1,
      type: "danger",
      message: "Se requiere seleccionar todos los campos..",
    };
  }

  loginform = true;
  recoverform = false;
  ennableInputs = false;
  ennableSpinner = true;

  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
  }
  company_identification: string = "";
  async getURLInformation(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.route.paramMap.subscribe({
        next: (params) => {
          const token = params.get("companyToken");

          if (token != null) {
            this.company_identification = token;
            localStorage.setItem("comp_login_token", token);
            resolve("Ok.");
          } else {
            reject("Token no encontrado en la URL.");
          }
        },
        error: (err) => {
          console.error("Error leyendo parámetro de ruta:", err);
          reject(err);
        },
      });
    });
  }
  async loadData() {
    sessionStorage.setItem("access_token_admin", "AIONSYSTEMSADMINTEMPURL");
    await this.getURLInformation();
    //console.log("Company ID:", this.company_identification);

    //consultar la api de companies mediante token --
    await this.getCompanySecurityInfo();
  }
  ngOnInit() {
    this.loadData();

    let session_active = localStorage.getItem("session_active_admin");

    if (session_active == "inactive" || session_active == null) {
      this.routes.navigate([
        "/login/" + localStorage.getItem("comp_login_token"),
      ]);
    } else {
      ///este hace que se haga autologin
      /*this.check(
        localStorage.getItem("username_enc_admin"),
        localStorage.getItem("psw_enc_admin")
      );*/
    }
  }
  checkLogginActive() {
    let session_active = localStorage.getItem("session_active_admin");
    if (session_active == "active") {
      this.check(
        localStorage.getItem("username_enc_admin"),
        localStorage.getItem("psw_enc_admin")
      );
    }
  }
  changePasswordModalFnc() {
    this.modalService.open(this.change_password_modal);
  }
  company_id_: number;
  company_branch_id_: number;
  async getCompanyBranchData() {
    this.company_service
      .getCompanyBranch(this.company_id_, this.company_branch_id_)
      .subscribe((res: any) => {
        localStorage.setItem(
          "company-branch-data",
          JSON.stringify(res.body[0])
        );
      });
  }
  async getEmployeesByID(employee_id: number): Promise<void> {
    console.log("employee_id", employee_id);
    try {
      const response: any = await this.employee_service
        .getEMployeesByID(employee_id, "null")
        .toPromise();
      console.log("response", response);
      if (response.status == 200 && response.data && response.data.length > 0) {
        const employeeData = response.data[0];
        this.company_id_ = employeeData.company_id;
        this.company_branch_id_ = employeeData.company_branch_id;

        localStorage.setItem("employee-data", JSON.stringify(employeeData));
        await this.getCompanyBranchData();
      } else {
        console.warn("No se encontró información del empleado.");
        throw new Error("Empleado no encontrado");
      }
    } catch (error) {
      this.staticAlertClosedLogin = false;
      this.alertLogin.type = "danger";
      this.alertLogin.message = "Error de Login.";
      this.resetLogin();
      this.ennableSpinner = true;
      this.ennableInputs = false;
      console.error("Error al obtener empleado:", error);
      throw error;
    }
  }
  check(uname: string, p: string) {
    this.tools.cleanCache();
    localStorage.setItem("username_enc_admin", uname);
    localStorage.setItem("psw_enc_admin", p);
    // console.log("this.company_identification ", this.company_identification);
    localStorage.setItem("comp_login_token", this.company_identification);
    localStorage.setItem("company_info", JSON.stringify(this.companyinfo));
    //Validar
    // debugger;
    this.ennableInputs = true;
    this.ennableSpinner = false;
    this.staticAlertClosedLogin = true;
    //console.log("------------------> " + uname);
    if (uname.length > 0 && p.length > 0) {
      this.authService.login(uname, p).subscribe(
        (res: any) => {
          this.msg = "";
          // console.log("login -->>>> ", res);
          if (res.api_code != "200") {
            this.staticAlertClosedLogin = false;
            this.alertLogin.type = "danger";
            this.alertLogin.message = "Error de login.";
            localStorage.setItem("session_active_admin", "inactive");

            this.resetLogin();
            this.ennableSpinner = true;
            this.ennableInputs = false;
          } else if (res.data[0].company_id == this.companyinfo.company_id) {
            localStorage.setItem("user_id", res.data[0].users_id);
            localStorage.setItem("role-code", res.data[0].code_rol);
            //__________________DATOS DE EMPLEADO
            if (
              res.data[0].code_rol != "clnt" &&
              res.data[0].code_rol != "clnt-admin"
            ) {
              localStorage.setItem(
                "employee_number",
                res.data[0].employee_number
              );
              this.getEmployeesByID(res.employee[0].employee_identity);
            } else {
              localStorage.setItem(
                "admin-customer-id",
                res.data[0].customer_id
              );
              localStorage.setItem(
                "admin-customer-branch-id",
                res.data[0].customer_branch_id
              );
            }
            //__________________OBTENER DATOS DE BECKET
            this.getBucketInfo();
            this.authService.obtenerMenu().subscribe((respMenu: any) => {
              let i = "";
              if (respMenu.body != null) {
                for (let itemMenu of respMenu.body) {
                  for (let itemSubMenu of itemMenu.submenu) {
                    if (itemSubMenu.is_default_page == 1) {
                      i = itemSubMenu.path;
                    }
                  }
                }
                let rol_code = localStorage.getItem("role-code");
                console.log(rol_code);
                console.error("Error....", rol_code.indexOf("clnt"));
                //en esta parte si no encuentra la ruta, se va a home, solo si no es cliente.
                if (i.length == 0 && rol_code.indexOf("clnt") == -1) {
                  i = "/home";
                } else if (rol_code.indexOf("clnt") == 0) {
                  //si es cliente
                  i = "/folder-validation";
                  this;
                } else {
                  //si es administrador
                  i = "/home";
                  this;
                }

                this.routes.navigate([i]);
              } else {
                console.log("Aqui");
                this.staticAlertClosedLogin = false;
                this.alertLogin.type = "danger";
                this.alertLogin.message = "Usuario no valido en este Sistema.";
                localStorage.setItem("session_active_admin", "inactive");

                this.resetLogin();
                this.ennableSpinner = true;
                this.ennableInputs = false;
                localStorage.setItem("session_active_admin", "inactive");
                this.routes.navigate([
                  "/login/" + localStorage.getItem("comp_login_token"),
                ]);
              }

              ////console.log("Error al consultar el menu -->",err);
            }),
              (error) => {
                console.log("Aqui");
                this.staticAlertClosedLogin = false;
                this.alertLogin.type = "danger";
                this.alertLogin.message = "Usuario no valido en este Sistema.";
                localStorage.setItem("session_active_admin", "inactive");

                this.resetLogin();
                this.ennableSpinner = true;
                this.ennableInputs = false;
                localStorage.setItem("session_active_admin", "inactive");
                this.routes.navigate([
                  "/login/" + localStorage.getItem("comp_login_token"),
                ]);
              };
          } else {
            this.staticAlertClosedLogin = false;
            this.alertLogin.type = "danger";
            this.alertLogin.message = "Error de login.";
            localStorage.setItem("session_active_admin", "inactive");

            this.resetLogin();
            this.ennableSpinner = true;
            this.ennableInputs = false;
          }
        },
        (err: any) => {
          this.staticAlertClosedLogin = false;
          this.alertLogin.type = "danger";
          this.alertLogin.message = "Usuario o contraseña incorrecto.";
          this.ennableSpinner = true;
          this.ennableInputs = false;
          this.resetLogin();
        }
      );
    } else {
      this.staticAlertClosedLogin = false;
      this.alertLogin.type = "danger";
      this.alertLogin.message = "Se requiere usuario y contraseña.";
      this.resetLogin();
      this.ennableSpinner = true;
      this.ennableInputs = false;
    }
  }
  user_data = {} as userData;
  email: string; //"ejemplo@gmail.com"   <---CUALQUIER CORREO
  email_phone_for_password: string;
  notificatoions: string;
  user_for_password: string;
  email_phone_option: string;

  checkIfPhoneOrEmail(txt: string) {
    let user_name = this.user_for_password;
    let phone_ = "";
    let email_ = "";
    if (txt.includes("@")) {
      email_ = this.email_phone_for_password;
    } else {
      phone_ = this.email_phone_for_password;
    }
    this.notificationService
      .getUserInformation(user_name, phone_, email_)
      .subscribe((res: any) => {
        console.log(res);
      });
  }
  getUserInfo(user: string, meta: string) {
    this.notificationService
      .sendMessageSMSEmail(this.user_data)
      .subscribe((res: any) => {});
  }
  sendMessage() {
    this.notificationService
      .sendMessageSMSEmail(this.user_data)
      .subscribe((res: any) => {});
  }
  resetLogin() {
    setTimeout(() => {
      this.staticAlertClosedLogin = true;
    }, 1500);
  }
  companyinfo = {} as companySecModel;

  getCompanySecurityInfo() {
    console.log("entrando");

    this.authService.getCompanyByToken(this.company_identification).subscribe(
      (res: any) => {
        console.log("respuesta");
        console.log("Resss", res);

        if (res.body && Array.isArray(res.body) && res.body.length > 0) {
          this.companyinfo = res.body[0];
          this.company_img = this.companyinfo.company_main_logo;
          console.log("Company_info:", this.companyinfo);
        } else {
          console.warn("No se encontró información de la empresa");
        }
      },
      (error) => {
        console.error("Error al obtener información de la empresa:", error);
      }
    );
  }

  getBucketInfo() {
    this.bucketService.loadBucketData().subscribe((res: any) => {
      if (res.status == 200) {
        this.bucketService.bucket = res.data[0];
        this.bucketService.bucket.endpoint = this.bucketService.bucket.endpoint;
      }
    });
  }
}

export interface IAlert {
  id: number;
  type: string;
  message: string;
}
export class userData {
  subject: string; //"Restablecimiento de contraseña", <---CUALQUIER ASUNTO
  mensaje: string; //"Restablecimiento de contraseña", <---CUALQUIER MENSAJE
  send_sms: number; //0,            <---0 NO ENVIA SMS, 1 ENVIA SMS
  send_email: number; //1,            <---0 NO ENVIA EMAIL, 1 ENVIA EMAIL
  mobile_num: string; //"000000000",    <---NUMERO DE 10 DIGITOS
  email: string; //"ejemplo@gmail.com"   <---CUALQUIER CORREO
}
